import React from 'react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-4 px-4 border-y border-white/10" data-id="element-157">
      <div className="max-w-xl mx-auto text-center text-xs md:text-sm font-bold text-brand-accent" data-id="element-158">
        <p data-id="element-159">
          +300 docentes confían | 6 Tomos maestros | 4 Bonos estratégicos |
          4.9/5 valoración
        </p>
      </div>
    </div>;
}